import type { MultiColumnData } from '../../types/chat';

export const DataTable = ({ data }: { data: MultiColumnData }) => {
  const processedData = data.data.map(row => {
    const processedRow: any = {};
    data.headers.forEach(header => {
      const value = row[header];
      if (Array.isArray(value)) {
        if (value.length === 0) {
          processedRow[header] = 'No data';
        } else if (value.length <= 300) {
          processedRow[header] = value;
        } else {
          processedRow[header] = `${value.length} items (${value.slice(0, 2).join(', ')}...)`;
        }
      } else if (typeof value === 'number') {
        processedRow[header] = value.toFixed(2);
      } else if (typeof value === 'object' && value !== null) {
        processedRow[header] = JSON.stringify(value).substring(0, 50) + '...';
      } else {
        processedRow[header] = value;
      }
    });
    return processedRow;
  });

  return (
    <div className="mt-4 rounded-xl overflow-hidden border border-gray-200 bg-white max-h-96 overflow-y-auto">
      <div className="px-4 py-3 bg-purple-50 border-b border-purple-200">
        <h3 className="font-semibold text-[#4c3794] text-sm">
          {data.title}
        </h3>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full border-collapse text-xs min-w-[600px]">
          <thead>
            <tr className="bg-purple-50">
              {data.headers.map((header, index) => (
                <th key={index} className="px-3 py-2 text-left font-semibold text-[#4c3794] border-b border-purple-200 text-xs whitespace-nowrap">
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {processedData.map((row, rowIndex) => (
              <tr key={rowIndex} className={rowIndex % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                {data.headers.map((header, colIndex) => (
                  <td key={colIndex} className="px-3 py-2 border-b border-gray-100 text-gray-700 text-xs max-w-[200px] break-words align-top">
                    {Array.isArray(row[header]) ? (
                      <ul className="m-0 pl-4 list-disc">
                        {row[header].map((item: any, index: number) => (
                          <li key={index} className="mb-1 text-xs leading-tight">
                            {item}
                          </li>
                        ))}
                      </ul>
                    ) : (
                      row[header]
                    )}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
